import { createReducer } from '@reduxjs/toolkit'

import { TFetchStatus } from 'redux/reducers/Dashboards'

import * as actions from '../../actions/AnalysisTypes/actions'
import * as authenticationActions from '../../actions/Authentication/actions'
import * as analysisActions from '../../actions/Analyses/actions'

import { TAnalysisTypeResponse } from 'redux/api/AnalysisTypes'

export interface AnalysisTypeReducerType {
  analysisTypes: TAnalysisTypeResponse[]
  fetchStatus: TFetchStatus

  /** The properties an analysis type can exclude, fetched when first needed. */
  realEstates: string[]
  realEstatesFetchStatus: TFetchStatus
}

const INITIAL_STATE: AnalysisTypeReducerType = {
  analysisTypes: [],
  fetchStatus: 'idle',
  realEstates: [],
  realEstatesFetchStatus: 'idle'
}

const analysisTypeReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetchStatus = 'fetching'
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.analysisTypes = action.payload
      state.fetchStatus = 'success'
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetchStatus = 'error'
    })
    .addCase(actions.getRealEstates, (state) => {
      state.realEstatesFetchStatus = 'fetching'
    })
    .addCase(actions.getRealEstatesSuccess, (state, action) => {
      state.realEstates = action.payload
      state.realEstatesFetchStatus = 'success'
    })
    .addCase(actions.getRealEstatesFailed, (state) => {
      state.realEstatesFetchStatus = 'error'
    })
    .addCase(actions.updateSettingsSuccess, (state, action) => {
      state.analysisTypes = state.analysisTypes.map((item) =>
        item.id === action.payload.id ? action.payload : item
      )
    })
    // An analysis comes with its analysis type, which may have changed.
    .addCase(analysisActions.getOneSuccess, (state, action) => {
      const analysisType = action.payload.included?.analysis_type

      if (analysisType) {
        state.analysisTypes = [
          ...state.analysisTypes.filter((item) => item.id !== analysisType.id),
          analysisType
        ]
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default analysisTypeReducer
